<template>
	<div>
		<p-panel-properties-group title="Action">
			<p-panel-properties>
				<p-property-tile icon="mdi-hammer" title="Trigger">
					<div style="width: 100px">
						<v-select
							v-model="value.data.trigger"
							:items="[
								{ text: 'Hover', value: ActionTrigger.hover },
								{ text: 'Click', value: ActionTrigger.click }
							]"
							:prepend-icon="
								value.data.trigger === ActionTrigger.click ? 'mdi-cursor-default-click' : 'mdi-cursor-pointer'
							"
							hide-details
							solo
							flat
							dense
						></v-select>
					</div>
				</p-property-tile>
			</p-panel-properties>
		</p-panel-properties-group>

		<p-panel-properties-group title="Front side">
			<flip-card-side-properties :sideProperties="value.data.front" />
		</p-panel-properties-group>

		<p-panel-properties-group title="Back side">
			<flip-card-side-properties :sideProperties="value.data.back" />
		</p-panel-properties-group>
	</div>
</template>

<script>
import PresetInputColor from '../../components/slides/styles/PresetInputColor.vue';
import PPanelPropertiesGroup from '../_components/utils/PPanelPropertiesGroup.vue';
import PPanelProperties from '../_components/utils/PPanelProperties.vue';
import PPropertyTile from '../_components/utils/PPropertyTile.vue';
import PPanelInputNumber from '../_components/utils/PPanelInputNumber.vue';
import { ActionTrigger } from './class.js';
import FlipCardSideProperties from './FlipCardSideProperties.vue';

export default {
	props: ['value'],
	components: {
		PresetInputColor,
		PPanelPropertiesGroup,
		PPanelProperties,
		PPropertyTile,
		PPanelInputNumber,
    FlipCardSideProperties
	},
	data() {
		return {
			ActionTrigger
		};
	}
};
</script>
